import axios from "axios";
import * as ROUTES from "../../../constants/routes";
import Helpers from "../../Helpers";

export default class AddUserFunction {
  constructor() {
    this.helpers = new Helpers();
  }

  doAddUser = (userName, password, mobileNumber, url, userType) => {
    const token = this.helpers.getCookie("token");
    return new Promise((resolve, reject) => {
      axios
        .post(
          url,
          JSON.stringify({
            email: userName,
            mobileNumber: "+63" + mobileNumber,
            password: password,
            userType,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          this.helpers.handleError(err);
          reject(err);
        });
    });
  };

  doAddUserDetails = (
    userId,
    firstname,
    lastname,
    mobileNumber,
    ustatus,
    email,
    userType,
    referralCode
  ) => {
    const token = this.helpers.getCookie("token");
    return new Promise((resolve, reject) => {
      axios
        .post(
          ROUTES.FUNCTIONAL_BASE_URL + "cms-admin/addData",
          JSON.stringify({
            useruid: userId,
            lastName: lastname,
            firstName: firstname,
            mobileNumber: "+63" + mobileNumber,
            status: ustatus,
            email,
            role: userType,
            referralCode,
          }),
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          resolve(res);
        })
        .catch((err) => {
          this.helpers.handleError(err);
          reject(err);
        });
    });
  };
}
